module.exports = __webpack_public_path__ + "img/stripe.0f0c8b5c.svg";